<template>
  <b-modal
    title="Create Membership"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset">
    <b-form>

    <b-row>
      <h2 v-show="createUserMembershipPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="createUserMembershipPending" color="#489AAC" size="50px"></pulse-loader>
    </b-row>

      <b-form-select
        id='selectedOrganization'
        size="lg"
        :options="memberOrganizationOptions(organizations)"
        v-model="morganization">
        <option :value="null" disabled>-- Please select an organization --</option>
      </b-form-select>

      <b-form-checkbox
        id="orgAdmin"
        v-model="isOrgAdmin"
        name="orgAdmin"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
        Organization Admin - Would you like this user to be able to share, unshare and transfer records on behalf of
        your organization?
      </b-form-checkbox>

      <b-form-checkbox
        id="orgManager"
        v-model="isManager"
        name="orgManager"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
        Organization Manager - Would you like this user to be able to view all of the records for your organization?
      </b-form-checkbox>

      <b-form-checkbox
        id="dwUser"
        v-model="isDWUser"
        name="dwUser"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
          Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?
      </b-form-checkbox>

      <b-form-checkbox
        id="careCoordinator"
        v-model="isCareCoordinator"
        name="careCoordinator"
        :unchecked-value="false"
        switch
        inline
        class="m-3">
        Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?
      </b-form-checkbox>
    </b-form>

    <b-alert
      fade
      :show="createUserMembershipFailure || _.isObject(createUserMembershipSuccess)"
      :variant="createUserMembershipFailure ? 'danger' : 'success'">
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="userMemberHandler">
        <span class="button-text">Create</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: 'create-user-Member-modal',
    props: {
      userId: Number,
      organizationId: Number,
      memOrg: Array,
      showModal: Boolean
    },
    data: function () {
      return {
        morganization: null,
        isOrgAdmin: false,
        isManager: false,
        isDWUser: false,
        isCareCoordinator: false
      }
    },
    watch: {
      createUserMembershipSuccess: function (newValue) {
        if (this.showModal) {
          _.delay(this.clearForm, 1000)
          _.delay(this.reset, 1100)
        }
      }
    },
    computed: {
      // Create a computed property that looks at userContextOrganizationGroups and filters out Groups as a result of orgs that are not the records owningOrg
      // Do you have org admin rights for the owningOrg for this record
      ...mapGetters({
        organizations: 'getAllOrganizations',
        createUserMembershipPending: 'createUserMembershipPending',
        createUserMembershipSuccess: 'createUserMembershipSuccess',
        createUserMembershipFailure: 'createUserMembershipFailure',
        newMembershipDefault: 'getCreateUserMembership'
      })
    },
    methods: {
      memberOrganizationOptions: function (organizations) {
        return _.sortBy(organizations, 'title').filter((item) => {
          return !(this.memOrg && this.memOrg.indexOf(item.id) > -1)
        }).map((org) => {
          return {
            value: org.id,
            text: org.title
          }
        })
      },
      reset: function () {
        this.$emit('update:showModal', false)
        this.clearForm()
      },
      userMemberHandler: function () {
        const userId = this.userId
        // not sure why is this?
        // if (!userId) {
        //   this.$store.commit('SET_USER_MEMBER_RESPONSE', {
        //     success: false,
        //     error: {
        //       code: 'INVALID_API_CALL',
        //       message: 'Incorrect parameters'
        //     }
        //   })
        // }

        if (userId && this.morganization) {
          this.$store.dispatch('createUserMembership', {
            muser: userId,
            morganization: this.morganization,
            isOrgAdmin: this.isOrgAdmin,
            isManager: this.isManager,
            isDWUser: this.isDWUser,
            isCareCoordinator: this.isCareCoordinator
          })
        }
      },
      apiResponseMessage: function () {
        let message = ''
        if (this.createUserMembershipSuccess) {
          message = 'Success!'
        }

        if (this.createUserMembershipFailure) {
          message = this.$utils.errorToHtml(this.createUserMembershipFailure)
        }

        return '<p>' + message + '</p>'
      },
      clearForm () {
        this.$store.commit('RESET_CREATE_USERMEMBER')
        this.isOrgAdmin = false
        this.isManager = false
        this.isDWUser = false
        this.isCareCoordinator = false
        this.morganization = null
      }
    },
    beforeDestroy () {
      this.reset()
    },
    created () {
      // Map default values from Vuex to the local state
      // for (const field in this.newMembershipDefault) {
      //   this.memberRecord[field] = this.newMembershipDefault[field]
      // }

      // this.memberRecord['muser'] = this.userId
      this.$store.dispatch('getOrganizations', {})
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Admin/CreateUserMemberModal.vue